import { inject, injectable } from "inversify";
import {
  IMostrarControleDebitosGateway,
  ITemDebitosSimplesResponse
} from "../ports/MostrarControleDebitosGateway";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/services/contabil/types";

@injectable()
export default class MostrarControleDebitosGatewayAdapter
  implements IMostrarControleDebitosGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  http!: HttpClient;

  async get(): Promise<ITemDebitosSimplesResponse> {
    const response = await this.http.get<
      IDefaultContabilResponse<ITemDebitosSimplesResponse>
    >({
      url: "v1/diagnostico/debitos-pgdas"
    });

    return response.body?.result || { temDebitoSimples: false };
  }
}
